import { GameTimes } from "./gameTimes";
import { parseSuccessfulResponse, RequestSender } from "./helpers";

async function getMyGameTimes(request: RequestSender) {
  const response = await request("get", `/profile/game-times`);
  return parseSuccessfulResponse(response, (data) => data as GameTimes);
}

export default getMyGameTimes;
